import {
  get,
  post,
  deleted,
  put
} from "api/api";
import Vue from "vue";
const _self = Vue.prototype



let defaultOption = {};
!(function (win, doc) {
  function SunTreeApi(opt) {
    this.opt = opt;
  };
  SunTreeApi.prototype.getDeptStationUserList = function (successCall, failCall) {
    get('/dept/stationUser').then(function (res) {
      if (res.success) {
        if (res.data) {
          // let data = _self.$formatterUtil.formatterDeptStation(res.data.rows)
          if (successCall) successCall(res.data.rows);
        }
      } else {
        if (failCall) failCall(res.data)
        else _self.$message.error(res.info);
      }
    })
  },
    SunTreeApi.prototype.logout = (_vue, successCall, failCall) => {
      get('/logout').then(res => {
        localStorage.clear()
        _vue.$store.commit('setUinfo', null)
        _vue.$store.commit('setDeptStationUserList', [])
        _vue.$store.commit('setAllUserUnip', [])
      })
      _vue.$router.push('/login')
    },
    SunTreeApi.prototype.clearLoginData = (_vue) => {
      localStorage.clear()
      _vue.$store.commit('setUinfo', null)
      _vue.$store.commit('setDeptStationUserList', [])
      _vue.$store.commit('setAllUserUnip', [])

      _vue.$router.push('/login')
    }

  win.SunTreeApi = new SunTreeApi(defaultOption);
})(window, document);

export default SunTreeApi



// WEBPACK FOOTER //
// ./src/components/api/index.js